const breadCrumb = "Lançamento de Notas - Lançar Justificativas";

const routes = [
  {
    path: "/emitir-relatorio-de-justificativa-de-ausencia-de-notas-conceito",
    name: "emitir-relatorio-de-justificativa-de-ausencia-de-notas-conceito",
    meta: {
      allowedPermissions: ["justificar_ausencia_nota_pdf"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/EmitirRalatorioDeJustificativaDeAusenciaDeNotasConceitos/EmitirRalatorioDeJustificativaDeAusenciaDeNotasConceitos.vue"
      ),
  },
];

export default routes;
